<div class="flex h-screen overflow-hidden bg-background">

  <!-- sidebar -->
  <aside class="shrink-0 sidebar-transition" [style.width]="layoutService.isSidebarCollapsed() ? '72px' : '260px'">
    <fk-sidebar></fk-sidebar>
  </aside>

  <!-- content -->
  <div class="flex-1 flex flex-col min-w-0">
    <fk-header></fk-header>
    <main class="flex-1 flex flex-col min-h-0 relative bg-[#f8fafc] overflow-y-auto">
      <router-outlet></router-outlet>
    </main>
  </div>

</div>